




































import { Component, Prop } from 'vue-property-decorator';
import { Checkbox } from '@/components/forms';
import { WidgetGeneric } from './WidgetGeneric';
import { getModule } from 'vuex-module-decorators';
import { MapStore } from '@/store/map';
import { Radio } from '@/components/forms';
import { MarkerTemplateParams, WidgetConfig } from '@/models/widget-config.model';

@Component({
  components: { Checkbox, Radio }
})
export default class WidgetInfrastructure extends WidgetGeneric {
  @Prop({ required: true, default: [] }) readonly checkboxes!: Record<string, any>[];
  @Prop({ required: true }) readonly closeOpenSubCategories!: (e: string) => void;

  freeMobile = false;

  created(): void {
    this._mapStore = getModule(MapStore, this.$store);
    this._points = new Map();
    this._widgetType = 'INFRASTRUCTURE';
    this._config = this._createConfig();
  }

  beforeDestroy(): void {
    this._config['INTERNET4G&5G'].tableNames.forEach(subType => {
      this.removeLayers(subType);
    });
    this.removeLayers('FreeMobile5G');
    this.removeLayers('internet-fibre');
    this._mapStore.setInternetLegend(false);
    this._mapStore.setInternetFibreLegend(false);
    this.checkboxes.forEach((checkbox: any) => {
      checkbox.selected = false;
      if (checkbox.open) checkbox.open = false;
      if (checkbox.subCat) {
        checkbox.subCat.forEach((el: any) => {
          el.selected = false;
        });
      }
    });
    this._beforeDestroy();
  }

  closeSubcategories(e: string) {
    this._config['INTERNET4G&5G'].tableNames.forEach(subType => {
      this.removeLayers(subType);
    });
    this.removeLayers('FreeMobile5G');
    this.closeOpenSubCategories(e);
  }

  removeLayers(type: string) {
    this._mapStore.removeLayer({ type });
    this._mapStore.removeSource({ type });
    this._mapStore.removeLayer({ type: `${type}Isohrone` });
    this._mapStore.removeSource({ type: `${type}Isohrone` });
    this._mapStore.removeLayer({ type: `${type}Icon` });
    this._mapStore.removeSource({ type: `${type}Icon` });
  }

  change({ type, value }: { type: string; value: boolean }) {
    if (this._config[type].tableNames) {
      this._config[type].tableNames.forEach(table => {
        if (this._points.has(table)) {
          this._points.get(table).visibility = value;
        }
      });
    } else if (this._points.has(type)) {
      this._points.get(type)!.visibility = value;
    }

    if (type === 'internet-fibre') {
      this._mapStore.setInternetFibreLegend(value);
      if (value) {
        this._addMapIsohrone(type);
      } else {
        this.removeLayers(type);
        this._removeInternetFibrePopup();
      }
      return;
    }
    if (['INTERNET4G&5G', 'free-mobile', 'bouygues', 'sfr', 'orange'].includes(type)) {
      this._mapStore.setInternetLegend(value);
      this._config['INTERNET4G&5G'].tableNames.forEach(subType => {
        this.removeLayers(subType);
      });
      this.removeLayers('FreeMobile5G');

      if (value) {
        if (type === 'INTERNET4G&5G') {
          type = 'free-mobile';
        }
        this._addToMapInternet4G5G(type, `${type}Isohrone`, `${type}Icon`);
        if (type === 'free-mobile') {
          this._addToMapInternet4G5G('FreeMobile5G', 'FreeMobile5GIcon');
          this.freeMobile = true;
        }
      }
      return;
    }

    if (this._config[type].tableNames) {
      this._config[type].tableNames.forEach(table => {
        if (this._points.has(table)) this._addToMap();
        else {
          this._getPoints(table).then(() => this._addToMap());
        }
      });
    } else if (this._points.has(type)) this._addToMap();
    else this._getPoints(type).then(() => this._addToMap());
  }

  private _createConfig(): WidgetConfig {
    const config: any = {};
    this.checkboxes.forEach((checkbox: Record<string, any>) => {
      config[checkbox.type] = { marker: WidgetInfrastructure._markerTemplate, tableName: checkbox.type };
      if (checkbox.subCat) {
        config[checkbox.type].tableNames = checkbox.subCat.map((el: any) => {
          config[el.type] = { marker: WidgetInfrastructure._markerTemplate };
          return el.type;
        });
      }
    });
    return config;
  }

  private static _markerTemplate({ type }: MarkerTemplateParams): HTMLDivElement {
    const markerElement = document.createElement('div');
    // markerElement.className = `marker-infrastructure marker-infrastructure--${type.toLowerCase()}`;
    markerElement.classList.add(
      'marker-infrastructure',
      `marker-infrastructure--${type.toLowerCase()}`,
      'background-color'
    );
    return markerElement;
  }

  destroyed(): void {
    this._mapStore.removeLayer({ type: this._widgetType });
    this._mapStore.removeSource({ type: this._widgetType });
    this._mapStore.removeLayer({ type: 'INFRASTRUCTURE_QUALITY_OF_LIFE_MULTIPOLYGON' });
    this._mapStore.removeSource({ type: 'INFRASTRUCTURE_QUALITY_OF_LIFE_MULTIPOLYGON' });
    this._removeInternetFibrePopup();
  }
}
